import { UiTypography } from '@/components/ui/Typography';
import { PHEON_SUPPORT_EMAIL, TERMS_LINK } from '@/constants';
import { StripeV2SubscriptionPrice } from '@/services/stripe/dto';

export function YearlyDescription({
  selectedPlan,
}: {
  selectedPlan: StripeV2SubscriptionPrice;
}) {
  return (
    <UiTypography
      variant="body-small"
      color="neutral-black"
      align="center"
      className="local-description"
    >
      You will be automatically charged ${selectedPlan.price} after the payment
      confirmation. The subscription will then be auto-renewed yearly unless
      it's cancelled. Payments are charged in USD, excluding taxes. To learn
      more, visit our{' '}
      <a href={TERMS_LINK} target="_blank">
        Terms of Use
      </a>{' '}
      or contact us via email{' '}
      <a href={`mailto:${PHEON_SUPPORT_EMAIL}`} target="_blank">
        {PHEON_SUPPORT_EMAIL}
      </a>
      .
    </UiTypography>
  );
}
